import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentService } from '../services/paymentService';
import { QUERY_KEYS } from '../utils/constants';
import { showSuccessToast, showErrorToast } from '../utils/toast';

// Payments
export const usePayments = (filters = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PAYMENTS, filters],
    queryFn: () => paymentService.getPayments(filters),
    refetchInterval: 30000, // Refetch every 30 seconds for real-time updates
  });
};

export const useMyPayments = (filters = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.MY_PAYMENTS, filters],
    queryFn: async () => {
      try {
        const data = await paymentService.getMyPayments(filters);
        return data;
      } catch (error) {
        console.error('Error fetching my payments:', error);
        throw error;
      }
    },
    onError: (error) => {
      console.error('useMyPayments error:', error);
    },
  });
};

export const usePaymentDetails = (id, options = {}) => {
  return useQuery({
    queryKey: QUERY_KEYS.PAYMENT_DETAILS(id),
    queryFn: () => paymentService.getPaymentDetails(id),
    enabled: options.enabled !== undefined ? options.enabled : !!id,
    ...options,
  });
};

export const usePendingPayments = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.PENDING_PAYMENTS],
    queryFn: () => paymentService.getPendingPayments(),
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};

export const useCreatePaymentRequest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (jobPostingId) => paymentService.createPaymentRequest(jobPostingId),
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.PAYMENTS]);
      queryClient.invalidateQueries([QUERY_KEYS.PENDING_PAYMENTS]);
      queryClient.invalidateQueries([QUERY_KEYS.ADMIN_COMPLETED_JOBS]);
      showSuccessToast('Payment request created successfully');
    },
    onError: (error) => {
      const errorMessage = error?.data?.detail || error?.message || 'Failed to create payment request';
      showErrorToast(errorMessage);
    }
  });
};

export const useProcessPayout = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ paymentId, notes }) => paymentService.processPayout(paymentId, notes),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([QUERY_KEYS.PAYMENTS]);
      queryClient.invalidateQueries([QUERY_KEYS.PENDING_PAYMENTS]);
      queryClient.invalidateQueries(QUERY_KEYS.PAYMENT_DETAILS(variables.paymentId));
      showSuccessToast('Employee payout processed successfully');
    },
    onError: (error) => {
      const errorMessage = error?.data?.detail || error?.message || 'Failed to process payout';
      showErrorToast(errorMessage);
    }
  });
};



